module.exports = __webpack_public_path__ + "fonts/Roboto-Medium1561b424aaef2f704bbd89155b3ce514.woff2]";